import API from '../../../API/api';
import {
    fittingOptionsComputeStarted,
    fittingOptionsComputeSuccess,
    fittingOptionsComputeFailed
} from '../../actions/http_request/product_mixed_stocks_fitting_options_compute_actions';
import Cart from '../../stores/models/cart';

/**
 * @param cart
 * @returns {*}
 */
function fittingOptionsComputeRequest(cart) {
    'use strict';

    fittingOptionsComputeStarted();
    if (!(cart instanceof Cart)) {
        fittingOptionsComputeFailed();
        return null;
    }

    let data = {
        items: [],
        shippingAddress: {
            ...cart.shippingAddress
        }
    };
    cart.items.map(item => {
        let cartItem = {
            productCode: item.productCode,
            stockType: item.stockType,
            itemStocks: [],
        };

        item.itemStocks.map((stock) => {
            let cartItemStock = {
                supplierStock: {
                    idSupplierStock: stock.supplierStock.idSupplierStock
                },
                qty: stock.qty
            };
            cartItem.itemStocks.push(cartItemStock);
        });

        data.items.push(cartItem);
    });
    const payload = JSON.stringify(data);

    return API.POST({
        apiPath: '/api/v2/carts/availablefittingoptions/compute/',
        data: payload,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8'
    }).catch(() => {
        fittingOptionsComputeFailed();
    }).done(() => {
        fittingOptionsComputeSuccess();
    });
}

export default fittingOptionsComputeRequest;